export default (value, [length]) => {
  if (value === undefined || value === null) {
    return length >= 0
  }

  return String(value).length <= length
}



// WEBPACK FOOTER //
// ./src/validator/max.js